import { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  TextField as InputField,
} from "@material-ui/core";
import { Button, useNotify } from "react-admin";
import { REGEX_MULTI_EMAIL, UserStatus } from "../../utils/constants";
import { logError } from "../../utils/appUtils";
import { sendEmail } from "../../utils/zapierUtils";
import { emailInviteHTML } from "./emailInviteHTML";
import { CancelIcon, EmailIcon } from "./iconography";

const handleSendEmail = async (data, toEmail, notify) => {
  debugger;
  try {
    const emailContent = emailInviteHTML(
      data.firstName,
      data.email,
      window.appUser?.firstName,
      window.appUser?.reloadYard.name
    );

    const emailSubject = "Your transloads.co Invite Is Waiting";

    const emailBody = {
      to: toEmail,
      subject: emailSubject,
      htmlContent: emailContent,
      template: "emailTemplate.html",
    };
    const optionsOverride = {
      createPdf: false,
    };
    sendEmail(
      emailBody,
      "common:SendInvitionButton:handleSendEmail",
      notify,
      optionsOverride
    );
  } catch (error) {
    logError("common:SendInviteButton:handleSendEmail", error, notify);
  }
};

export const SendInviteButton = ({ data, label, title, ...props }) => {
  const notify = useNotify();
  const [toEmail, setToEmail] = useState(data?.email);
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [ccEmail, setCcEmail] = useState("");
  const [emailOpen, setEmailOpen] = useState(false);

  useEffect(() => {
    if (data?.email) setToEmail(data.email);
  }, [data?.email]);

  const handleEmailChange = (event) => {
    const emailInput = event.target.value;
    setToEmail(emailInput);
  };

  const handleEmailBlur = () => {
    setIsEmailValid(validateEmail(toEmail));
  };

  const validateEmail = (email) => {
    if (email) return REGEX_MULTI_EMAIL.test(email.trim());
    return true;
  };

  const handleDialogOpen = () => setEmailOpen(true);
  const handleDialogClose = () => setEmailOpen(false);

  const handleSubmit = async () => {
    const valid = validateEmail(toEmail);
    if (valid) setIsEmailValid(valid);
    else return;

    setTimeout(() => {
      handleSendEmail(data, toEmail, notify);
    }, 0);

    setEmailOpen(false);
  };

  if (data?.status !== UserStatus.PENDING_REG) return null;
  return (
    <>
      <Button
        {...props}
        label={label}
        color="primary"
        onClick={handleDialogOpen}
        disabled={!data?.email}
      >
        <EmailIcon />
      </Button>
      {emailOpen && (
        <Dialog
          open={emailOpen}
          maxWidth="sm"
          onClose={handleDialogClose}
          fullWidth
        >
          <DialogTitle>{title}</DialogTitle>
          <DialogContent>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <InputField
                  label="To email"
                  size="small"
                  variant="outlined"
                  fullWidth
                  required
                  value={toEmail}
                  error={!isEmailValid} // Display error state based on validation
                  helperText={
                    !isEmailValid
                      ? "Please enter a valid email address."
                      : false
                  }
                  onChange={handleEmailChange}
                  onBlur={handleEmailBlur}
                />
              </Grid>
              <Grid item xs={12}>
                <InputField
                  label="CC"
                  size="small"
                  variant="outlined"
                  fullWidth
                  helperText="Comma-separated email(s)"
                  value={ccEmail}
                  onChange={(event) => setCcEmail(event.target.value)}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button label="CANCEL" color="default" onClick={handleDialogClose}>
              <CancelIcon />
            </Button>
            <Button label="SEND" color="primary" onClick={handleSubmit}>
              <EmailIcon />
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};
